// 查看历史版本参照  资质审核模板
/* global $ u */
import Collection from 'common/vo/collection'
import 'collection/qualifyTplHistory'
// import collection from 'collection/qualifyTplHistory'
import operation from './opt'
function init (refer) {
  // debugger
  // 每次都重新加载表格
  let collection = Collection.create('collection.qualifyTplHistory')
  collection.load({code: refer.params.code})
  let vm = {
    config: {
      'id': 'gridperson',
      'data': collection,
      'type': 'grid',
      'multiSelect': false,
      'editable': false,
      pagination: true,
      fields: [{
        'field': 'versionNo',
        'dataType': 'String',
        'title': '版本号',
        'width': '20%'
      }, {
        'field': 'createTime',
        'dataType': 'Date',
        'title': '创建时间',
        'width': '25%',
        'format': 'YYYY-MM-DD'
      }, {
        'field': 'creatorName',
        'dataType': 'String',
        'title': '创建人',
        'width': '25%'
      }, {
        'field': 'operation',
        'title': '操作',
        'width': '30%',
        dataType: 'action',
        item: operation({
        })
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#tplCerHisfer')[0])
}
let template = require('./index.html')
export default{
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/qualiftTplRefer/index.js